module.exports = __webpack_public_path__ + "img/log_w.440082b0.png";